import i18n from '../i18n';

export default class AnswerType {
  public static readonly UNDEFINED = new AnswerType('', '全て');
  public static readonly UNANSWERED = new AnswerType('0', '未回答');
  public static readonly ADDTOLAS = new AnswerType('01', 'LASに追加登録');
  public static readonly STOCK = new AnswerType('02', 'しばらく保管');
  public static readonly NOTME = new AnswerType('03', '注文した覚えがありません');
  public static readonly MODORDEL = new AnswerType('04', 'LAS削除(数量修正)');
  public static readonly ALREADY = new AnswerType('05', '既にLASにあります');
  public static readonly DELETE = new AnswerType('06', '廃棄');
  public static readonly RETURN = new AnswerType('07', '返品');
  public static readonly REGAMAZON = new AnswerType('08', 'Amazonに登録完了');
  public static readonly NEWTOLAS = new AnswerType('09', 'LASに登録完了');
  public static readonly B08NXS1WJ7A1 = new AnswerType('10', '５点にバラして入庫');
  public static readonly B08NXS1WJ7A2 = new AnswerType('11', '5BOX １セットです');
  public static readonly TEMP1 = new AnswerType('98', 'その他');
  public static readonly TEMP2 = new AnswerType('99', '対応済み');

  // 全部
  public static values(): any {
    return [
      { value: this.UNDEFINED.value, text: i18n.t(this.UNDEFINED.text) },
      { value: this.UNANSWERED.value, text: i18n.t(this.UNANSWERED.text) },
      { value: this.ADDTOLAS.value, text: i18n.t(this.ADDTOLAS.text) },
      { value: this.STOCK.value, text: i18n.t(this.STOCK.text) },
      { value: this.NOTME.value, text: i18n.t(this.NOTME.text) },
      { value: this.MODORDEL.value, text: i18n.t(this.MODORDEL.text) },
      { value: this.ALREADY.value, text: i18n.t(this.ALREADY.text) },
      { value: this.DELETE.value, text: i18n.t(this.DELETE.text) },
      { value: this.RETURN.value, text: i18n.t(this.RETURN.text) },
      { value: this.REGAMAZON.value, text: i18n.t(this.REGAMAZON.text) },
      { value: this.NEWTOLAS.value, text: i18n.t(this.NEWTOLAS.text) },
      { value: this.B08NXS1WJ7A1.value, text: i18n.t(this.B08NXS1WJ7A1.text) },
      { value: this.B08NXS1WJ7A2.value, text: i18n.t(this.B08NXS1WJ7A2.text) },
      { value: this.TEMP1.value, text: i18n.t(this.TEMP1.text) },
      { value: this.TEMP2.value, text: i18n.t(this.TEMP2.text) },
    ];
  }

  // 数量不一致
  public static values1(): any {
    return [
      { value: this.UNANSWERED.value, text: i18n.t(this.UNANSWERED.text) },
      { value: this.ADDTOLAS.value, text: i18n.t(this.ADDTOLAS.text) },
      { value: this.RETURN.value, text: i18n.t(this.RETURN.text) },
      { value: this.DELETE.value, text: i18n.t(this.DELETE.text) },
      { value: this.MODORDEL.value, text: i18n.t(this.MODORDEL.text) },
      { value: this.STOCK.value, text: i18n.t(this.STOCK.text) },
      { value: this.NOTME.value, text: i18n.t(this.NOTME.text) },
      { value: this.TEMP1.value, text: i18n.t(this.TEMP1.text) },
    ];
  }

  // SKU登録無し、ASIN無効
  public static values2(): any {
    return [
      { value: this.UNANSWERED.value, text: i18n.t(this.UNANSWERED.text) },
      { value: this.REGAMAZON.value, text: i18n.t(this.REGAMAZON.text) },
      { value: this.RETURN.value, text: i18n.t(this.RETURN.text) },
      { value: this.DELETE.value, text: i18n.t(this.DELETE.text) },
      { value: this.STOCK.value, text: i18n.t(this.STOCK.text) },
      { value: this.NOTME.value, text: i18n.t(this.NOTME.text) },
      { value: this.TEMP1.value, text: i18n.t(this.TEMP1.text) },
    ];
  }

  // LAS登録無し
  public static values3(): any {
    return [
      { value: this.UNANSWERED.value, text: i18n.t(this.UNANSWERED.text) },
      { value: this.NEWTOLAS.value, text: i18n.t(this.NEWTOLAS.text) },
      { value: this.ALREADY.value, text: i18n.t(this.ALREADY.text) },
      { value: this.RETURN.value, text: i18n.t(this.RETURN.text) },
      { value: this.DELETE.value, text: i18n.t(this.DELETE.text) },
      { value: this.STOCK.value, text: i18n.t(this.STOCK.text) },
      { value: this.NOTME.value, text: i18n.t(this.NOTME.text) },
      { value: this.TEMP1.value, text: i18n.t(this.TEMP1.text) },
    ];
  }

  // 輸出不可、SDSが必要、その他
  public static values4(): any {
    return [
      { value: this.UNANSWERED.value, text: i18n.t(this.UNANSWERED.text) },
      { value: this.RETURN.value, text: i18n.t(this.RETURN.text) },
      { value: this.DELETE.value, text: i18n.t(this.DELETE.text) },
      { value: this.STOCK.value, text: i18n.t(this.STOCK.text) },
      { value: this.NOTME.value, text: i18n.t(this.NOTME.text) },
      { value: this.TEMP1.value, text: i18n.t(this.TEMP1.text) },
    ];
  }

  // ASIN[B08NXS1WJ7]の回答選択
  public static values5(): any {
    return [
      { value: this.UNANSWERED.value, text: i18n.t(this.UNANSWERED.text) },
      { value: this.B08NXS1WJ7A1.value, text: i18n.t(this.B08NXS1WJ7A1.text) },
      { value: this.B08NXS1WJ7A2.value, text: i18n.t(this.B08NXS1WJ7A2.text) },
    ];
  }

  // public static valueOf(value: string): AnswerType {
  //   for (const v of this.values()) {
  //     if (v.value === value) {
  //       return v;
  //     }
  //   }
  //   return AnswerType.UNDEFINED;
  // }

  private constructor(public readonly value: string, public readonly text: string) {}
  public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: AnswerType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
